import React from 'react';
import bigLogoPlug from '../../assets/img/big-logo.png';
import smallLogoPlug from '../../assets/img/small-logo.png';
import CustomInput, { ErrorText } from '../CustomInput/CustomInput';
import { Upload, Trash } from '../Svg/Svg';
import { countryCodesMap } from '../../shared/data/countryCodesMap';

export default function LogosUploader({
    onFileSelect,
    bigLogo,
    smallLogo,
    favicon,
    emailLogo,
    bigLogoErrors,
    smallLogoErrors,
    faviconErrors,
    emailLogoErrors,
    onDeleteLogo,
    bigLogoButtonRef,
    smallLogoButtonRef,
    faviconButtonRef,
    emailLogoButtonRef,
    flag,
    isFaviconEnabled = false,
    onLogosSizesChange,
    logosSizes,
}) {
    return (
        <div className="form__upload-wrapper">
            <div>
                <p className="form__upload-title">Logo (login page: web app)</p>
                <div className="form__upload-container">
                    <img
                        className="form__upload-image"
                        width={64}
                        height={64}
                        src={bigLogo?.logoUrl || bigLogoPlug}
                        alt="Big logo"
                    />
                    <div className="form__upload">
                        <div className="form__upload-buttons-wrapper">
                            <input
                                type="file"
                                name="big-logo"
                                id={`big-logo-${flag}`}
                                ref={bigLogoButtonRef}
                                className="input-file"
                                accept="image/svg, image/png, image/jpeg"
                                onChange={(e) => onFileSelect(e, flag)}
                            />
                            <label
                                className="form__upload-button"
                                htmlFor={`big-logo-${flag}`}
                            >
                                <Upload />
                                <span className="form__upload-button-text">
                                    Upload
                                </span>
                            </label>
                            {bigLogo?.logoUrl ? (
                                <button
                                    className="form__trash-button"
                                    name="big-logo"
                                    onClick={(e) => onDeleteLogo(e, flag)}
                                >
                                    <Trash />
                                </button>
                            ) : (
                                <div
                                    style={{
                                        width: '32px',
                                        height: '32px',
                                    }}
                                ></div>
                            )}
                        </div>
                        <span className="form__upload-text">
                            64 x 64&nbsp;&nbsp;
                            <span className="form__upload-text-devider">
                                &bull;
                            </span>
                            &nbsp;&nbsp; svg or png
                        </span>
                    </div>
                </div>
                {bigLogoErrors?.isWrongFileType && (
                    <ErrorText text={'Wrong file format'} />
                )}
                {bigLogoErrors?.isFileOversized && (
                    <ErrorText text={'The file size must not exceed 2MB'} />
                )}
                <div style={{ display: 'flex', marginTop: '10px' }}>
                    <div style={{ maxWidth: '100px', marginRight: '10px' }}>
                        <CustomInput
                            id="logo_width"
                            onInputChange={(e) => onLogosSizesChange(e, flag)}
                            inputValue={
                                logosSizes.web_app.logo[countryCodesMap[flag]]
                                    ?.width
                            }
                            type="number"
                            labelClass="input-label--normal"
                            labelText="Logo width (px)"
                            width="100%"
                        />
                    </div>
                    <div style={{ maxWidth: '100px' }}>
                        <CustomInput
                            id="logo_height"
                            onInputChange={(e) => onLogosSizesChange(e, flag)}
                            inputValue={
                                logosSizes.web_app.logo[countryCodesMap[flag]]
                                    ?.height
                            }
                            labelText="Logo height (px)"
                            labelClass="input-label--normal"
                            type="number"
                            width="100%"
                        />
                    </div>
                </div>
            </div>
            <div>
                <p className="form__upload-title">Email template</p>
                <div className="form__upload-container">
                    <img
                        className="form__upload-image"
                        width={64}
                        height={64}
                        src={emailLogo?.logoUrl || bigLogoPlug}
                        alt="Email logo"
                    />
                    <div className="form__upload">
                        <div className="form__upload-buttons-wrapper">
                            <input
                                type="file"
                                name="email-logo"
                                id={`email-logo-${flag}`}
                                ref={emailLogoButtonRef}
                                className="input-file"
                                accept="image/png, image/jpeg"
                                onChange={(e) => onFileSelect(e, flag)}
                            />
                            <label
                                className="form__upload-button"
                                htmlFor={`email-logo-${flag}`}
                            >
                                <Upload />
                                <span className="form__upload-button-text">
                                    Upload
                                </span>
                            </label>
                            {emailLogo?.logoUrl ? (
                                <button
                                    className="form__trash-button"
                                    name="email-logo"
                                    onClick={(e) => onDeleteLogo(e, flag)}
                                >
                                    <Trash />
                                </button>
                            ) : (
                                <div
                                    style={{
                                        width: '32px',
                                        height: '32px',
                                    }}
                                ></div>
                            )}
                        </div>
                        <span className="form__upload-text">
                            64 x 64&nbsp;&nbsp;
                            <span className="form__upload-text-devider">
                                &bull;
                            </span>
                            &nbsp;&nbsp; png
                        </span>
                    </div>
                </div>
                {emailLogoErrors?.isWrongFileType && (
                    <ErrorText text={'Wrong file format'} />
                )}
                {emailLogoErrors?.isFileOversized && (
                    <ErrorText text={'The file size must not exceed 2MB'} />
                )}
            </div>
            <div>
                <p className="form__upload-title">Mark (mobile, desktop)</p>
                <div className="form__upload-container">
                    <img
                        className="form__upload-image"
                        src={smallLogo?.logoUrl || smallLogoPlug}
                        alt="Small logo"
                        width={32}
                        height={32}
                    />
                    <div className="form__upload">
                        <div className="form__upload-buttons-wrapper">
                            <input
                                type="file"
                                name="small-logo"
                                id={`small-logo-${flag}`}
                                ref={smallLogoButtonRef}
                                className="input-file"
                                accept="image/svg, image/png, image/jpeg"
                                onChange={(e) => onFileSelect(e, flag)}
                            />
                            <label
                                className="form__upload-button"
                                htmlFor={`small-logo-${flag}`}
                            >
                                <Upload />
                                <span className="form__upload-button-text">
                                    Upload
                                </span>
                            </label>
                            {smallLogo?.logoUrl ? (
                                <button
                                    className="form__trash-button"
                                    name="small-logo"
                                    onClick={(e) => onDeleteLogo(e, flag)}
                                >
                                    <Trash />
                                </button>
                            ) : (
                                <div
                                    style={{
                                        width: '32px',
                                        height: '32px',
                                    }}
                                ></div>
                            )}
                        </div>
                        <span className="form__upload-text">
                            32 x 32&nbsp;&nbsp;
                            <span className="form__upload-text-devider">
                                &bull;
                            </span>
                            &nbsp;&nbsp; svg or png
                        </span>
                    </div>
                </div>
                {smallLogoErrors?.isWrongFileType && (
                    <ErrorText text={'Wrong file format'} />
                )}
                {smallLogoErrors?.isFileOversized && (
                    <ErrorText text={'The file size must not exceed 2MB'} />
                )}
            </div>
            {isFaviconEnabled && (
                <div>
                    <p className="form__upload-title">Favicon (web app)</p>
                    <div className="form__upload-container">
                        <img
                            className="form__upload-image"
                            src={favicon?.logoUrl || smallLogoPlug}
                            alt="Favicon"
                            width={32}
                            height={32}
                        />
                        <div className="form__upload">
                            <div className="form__upload-buttons-wrapper">
                                <input
                                    type="file"
                                    name="favicon"
                                    id={`favicon-${flag}`}
                                    ref={faviconButtonRef}
                                    className="input-file"
                                    accept="image/svg, image/png, image/jpeg"
                                    onChange={(e) => onFileSelect(e, flag)}
                                />
                                <label
                                    className="form__upload-button"
                                    htmlFor={`favicon-${flag}`}
                                >
                                    <Upload />
                                    <span className="form__upload-button-text">
                                        Upload
                                    </span>
                                </label>
                                {favicon?.logoUrl ? (
                                    <button
                                        className="form__trash-button"
                                        name="favicon"
                                        onClick={(e) => onDeleteLogo(e, flag)}
                                    >
                                        <Trash />
                                    </button>
                                ) : (
                                    <div
                                        style={{
                                            width: '32px',
                                            height: '32px',
                                        }}
                                    ></div>
                                )}
                            </div>
                            <span className="form__upload-text">
                                32 x 32&nbsp;&nbsp;
                                <span className="form__upload-text-devider">
                                    &bull;
                                </span>
                                &nbsp;&nbsp; svg or png
                            </span>
                        </div>
                    </div>
                    {faviconErrors?.isWrongFileType && (
                        <ErrorText text={'Wrong file format'} />
                    )}
                    {faviconErrors?.isFileOversized && (
                        <ErrorText text={'The file size must not exceed 2MB'} />
                    )}
                </div>
            )}
        </div>
    );
}
